<template>
  <div>
    <div class="content">
      <div class="row align-items-center">
        <div class="col-md-6"></div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="loading">
      <loading />
    </div>
    <div class="row">
      <div class="col-md-12">
        <Titulo
          title="Solicitações"
          description="Acompanhamento de solicitações cadastradas"
        />
        <div class="row justify-content-center" v-if="loading">
          <loading />
        </div>
        <div v-else-if="lista.length > 0">
          <ListaConciliador class="mt-5" :lista="lista" />
        </div>
        <div class="col-12" v-else>
          <div
            class="border-0 py-5 d-flex justify-content-center align-items-center"
          >
            <h5>Nenhuma solicitação encontrado. 😟</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import ListaConciliador from "@/components/cadastro/ListaConciliador";

export default {
  name: "Lista",
  components: { Titulo, ListaConciliador },
  data() {
    return {
      produto: {
        nome: "SPC Conciliador",
        id: "spcConciliador",
      },
      breadcrumb: [
        {
          nome: "SPC Conciliador",
          id: "spcConciliador",
          produto: "SPC Conciliador",
        },
      ],
      lista: [],
      loading: true,
      menu: 1,
      descMenu: "ANÚNCIO",
      linkCadastro: "/produto/spc-conciliador/planos",
    };
  },
  methods: {
    consultarDados() {
      this.lista = [];
      this.loading = true;
      this.$http
        .get(`/api/Clube/ConsultarFuncionariosClubeVantagens`)
        .then((response) => {
          this.loading = false;
          this.lista = response.data.funcionarios;
          this.qtdRegistros = response.data.totalLinhas;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }

          this.loading = false;
          this.error = error.response.data.mensagem;
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;
    localStorage.removeItem("spc_conciliador");

    this.$http
      .get("/api/Conciliador/ConsultarSpcConciliador")
      .then((response) => {
        if (response.data.dtAceite) {
          var strOperadoras = null;
          var status = null;
          var pagamento = false;
          var exibirBotao = true;
          response.data.operadoras.forEach((el) => {
            strOperadoras = strOperadoras ? ", " + el.descricao : el.descricao;
          });

          if (response.data.status == false) {
            status = response.data.statusChamado;
            // Se o chamado for aprovado, habilita botão do pagamento
            if (response.data.statusChamado == "Classificado") {
              pagamento = true;
            }
          } else {
            status = "Ativo";
            exibirBotao = false;
          }

          this.lista.push({
            descricao: response.data.plano.descricao,
            qtdCnpj: response.data.qtdeCNPJs,
            operadoras: strOperadoras,
            status: status,
            pagamento: pagamento,
            exibirBotao: exibirBotao,
          });
        } else {
          this.$router.push({ name: "institucional" });
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
          this.$router.push({ name: "institucional" });
        }
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });
  },
};
</script>
<style lang="scss" scoped>
@media screen and(max-width: 900px) {
  #v-pills-tab {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin-bottom: 1rem;
    a {
      width: 22%;
      text-align: center;
      justify-content: center;
      align-items: center;
      span {
        display: none;
      }
    }
  }
}
</style>
